module.exports = __webpack_public_path__ + "media/onboarding/example-cpa-dfdde630.png";